import type { PaidStore } from './interfaces'

import { useActivationStore } from '@entities/activation'
import { useBookingStore } from '@entities/booking'
import { isBookingCancelTime } from '@entities/booking'
import { useRawCurrentTime } from '@entities/customer'

import { AllLessonsSwitcher } from './enums'

export const getters = {
  isLoading: (state: PaidStore): PaidStore['loading'] => state.loading,
  isProcessing: (state: PaidStore): PaidStore['processing'] => state.processing,
  getModalReschedule: (state: PaidStore): PaidStore['modalReschedule'] => state.modalReschedule,
  isModalReschedule: (state: PaidStore): boolean => !!state.modalReschedule,
  getModalFirstLessonAttend: (state: PaidStore): PaidStore['modalFirstLessonAttend'] => state.modalFirstLessonAttend,
  isModalFirstLessonAttend: (state: PaidStore): boolean => !!state.modalFirstLessonAttend,
  /**
   * A modal that outranks the first-lesson onboarding is up — or a welcome-email action is still
   * deciding which one to open. Both welcome-email outcomes (attend, reschedule) block it.
   */
  isPriorityModalOpen: (state: PaidStore): boolean =>
    state.firstLessonAttendPending
    || !!state.modalFirstLessonAttend
    || !!state.modalReschedule,
  getModalCancel: (state: PaidStore): PaidStore['modalCancel'] => state.modalCancel,
  isBadCancel: (state: PaidStore): boolean => {
    const booking = state.modalCancel || null
    return booking ? isBookingCancelTime(booking, useRawCurrentTime().currentTime) : false
  },
  isModalCancel: (state: PaidStore): boolean => !!state.modalCancel,
  getBookingDate: (state: PaidStore): PaidStore['bookingDate'] => state.bookingDate,
  getAvailableSlots: (state: PaidStore): PaidStore['availableSlots'] => state.availableSlots,
  getRescheduleDate: (state: PaidStore): PaidStore['rescheduleDate'] => state.rescheduleDate,
  isRescheduleDate: (state: PaidStore): boolean => !!state.rescheduleDate,
  getRescheduleTime: (state: PaidStore): PaidStore['rescheduleTime'] => state.rescheduleTime,
  isRescheduleTime: (state: PaidStore): boolean => !!state.rescheduleTime,
  getTriggerRescheduleSelect: (state: PaidStore): PaidStore['triggerRescheduleSelect'] => state.triggerRescheduleSelect,
  isAllLessonsSwitcherUpcoming: (state: PaidStore): boolean => state.allLessonsSwitcher === AllLessonsSwitcher.Upcoming,
  isAllLessonsSwitcherPast: (state: PaidStore): boolean => state.allLessonsSwitcher === AllLessonsSwitcher.Past,
  isModalUpsell: (state: PaidStore): PaidStore['modalUpsell'] => state.modalUpsell,
  isShowPaidBooking: (): boolean => {
    const activationStore = useActivationStore()
    const bookingStore = useBookingStore()

    return !activationStore.isActivationCompleted && bookingStore.hasCurrentBooking
  },
}
